import { commonFilter } from './filter';

export default {
  pageName: 'VoiceReportingTextAnalysis',
  pageId: '25040',
  pagePath: '/opinion/Report/VoiceReportingTextAnalysis',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    GPT_Get_Btn: {
      buttonId: '25040001',
    },
    GPT_Stop: {
      buttonId: '25040002',
    },
    GPT_Type: {
      buttonId: '25040003',
    },
    GPT_Confirm: {
      buttonId: '25040004',
    },
    GPT_Agent: {
      buttonId: '25040005',
    },
  },
  card: {
    IntentDistributionTrend: {
      bar: {
        buttonId: '25040100',
      },
      line: {
        buttonId: '25040101',
      },
      stack_line: {
        buttonId: '25040103',
      },
      table: {
        buttonId: '25040104',
      },
      download: {
        buttonId: '25040105',
      },
    },
    Details: {
      download: '25040106',
    },
  },
};
